
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MoonLoader from "react-spinners/MoonLoader"; // Assuming you have this

const PrivateRoute = ({ children, validRole }) => {
  const { token, tokenVerified, user: { role } } = useSelector((state) => state.auth);
  
  if (!token) return <Navigate to="/login" />;
  if (!tokenVerified) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <MoonLoader color="#00BFFF" size={50} />
    </div>
  );
  if (!validRole.includes(role)) return <Navigate to="/login" />;
  
  return children;
};


export default PrivateRoute;